export const ATTACHMENT_DEFAULT_VALUES = {
  Description: '',
  codeAttachmentType: '',
  IsDeleted: false,
};
